import { render, staticRenderFns } from "./companyEdit.vue?vue&type=template&id=6a5c02d2&scoped=true&"
import script from "./companyEdit.vue?vue&type=script&lang=js&"
export * from "./companyEdit.vue?vue&type=script&lang=js&"
import style0 from "./companyEdit.vue?vue&type=style&index=0&id=6a5c02d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5c02d2",
  null
  
)

export default component.exports